import React from 'react';
import { EMAIL_CONNECTION_MODALS_ENUM } from '@/utils/constants/connectedEmails';
import { timeAgo } from '@/utils/ts/stringUtils';
import { useNavigate } from 'react-router-dom';

import { dayjs } from '../../../utils/dayjs-utils';
import RightArrow from '../../Icons/icons/RightArrow';
import ButtonComponent from '../ButtonComponent/ButtonComponent';

export default function EmailDisconnectNotification({ notification }) {
  const navigate = useNavigate();

  const message = notification?.content?.body;

  const email = message.match(/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,7}\b/)[0];
  const emailIndex = message.indexOf(email);

  const beforeEmail = message.substring(0, emailIndex).trim();
  const afterEmail = message.substring(emailIndex + email.length).trim();
  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">📫</div>
      <div className="text-div" style={{ marginLeft: 6 }}>
        {/* <h3 className="title">{notification?.title}</h3> */}
        <p className="description" style={{ color: 'var(--text-default)', fontSize: '14px' }}>
          {beforeEmail} <span style={{ display: 'contents', fontWeight: '500' }}>{email}</span> {afterEmail}
        </p>
        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            style={{ padding: '0px' }}
            textStyle={{ fontSize: '14px' }}
            onClick={() => {
              navigate(`/dashboard/settings?tab=connected-emails`, {
                state: {
                  activeModal: EMAIL_CONNECTION_MODALS_ENUM.EMAIL_CONNECTION,
                  disconnectedEmail: notification?.content?.disconnectedEmail?.email,
                  name: notification?.content?.disconnectedEmail?.fromName,
                  provider: notification?.content?.disconnectedEmail?.provider,
                },
              });
            }}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            Reconnect
          </ButtonComponent>
        </div>
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
}
